import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudGenericsService } from '../common/crud-generics';
import { Environment, ArticoliCategorieSub } from '../../models/-index';
import { Observable } from 'rxjs';

@Injectable()
export class ArticoliCategorieSubService extends CrudGenericsService<ArticoliCategorieSub, number> {
  private base: string;

  constructor(protected http: HttpClient, @Inject('ENV') env: Environment) {
    super(http, `${env.apiUrl}/api/ArticoliCategorieSub`);
    this.base = `${env.apiUrl}/api/ArticoliCategorieSub/`;
  }
  GetAll_ByArtCategoria(id_cat: number = 0): Observable<ArticoliCategorieSub[]> {
    const u = `${this.base}GetAll_ByArtCategoria?id=${id_cat}`;
    return this.http.get<ArticoliCategorieSub[]>(u);
  }
}
